import React from "react";
import PropTypes from "prop-types";
import ImageLibpixel from "./image-libpixel.js";
import { _ } from "../utils/i18n";

const InfoGrid = ({ data }) => {
  var blockData = data;

  return (
    <div className="career-employee-wrapper">
      {blockData &&
        blockData?.items &&
        blockData?.items?.map((l, i) => (
          <div key={i} className="career-employee-container">
            <ImageLibpixel
              src={l.img.sourceUrl}
              alt={_("Karriere")}
              className="career-employee-img"
            />
            <div className="employee-textbox">
              <p className="employee-name">{l.title && l.title}</p>
              <p className="employee-quote">{l.text && l.text}</p>
            </div>
          </div>
        ))}
    </div>
  );
};

InfoGrid.propTypes = {
  data: PropTypes.array,
};

InfoGrid.defaultProps = {
  data: undefined,
};

export default InfoGrid;
